module.exports = __webpack_public_path__ + "static/media/logo.611fe09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 408
// module chunks = 0